import { IconProps } from '.';

const HouseIcon = ({
  color = 'bg-skin-stroke-primary',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <g id="home-plans">
        <path
          id="Vector 126 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1837 42.333V2.45801H23.8087V42.333H20.1837Z"
          fill={color}
        />
        <path
          id="Vector 127 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9087 1.00801C21.5532 0.524674 22.4393 0.524674 23.0837 1.00801L42.4171 15.508C42.8735 15.8503 43.1421 16.3875 43.1421 16.958V42.333C43.1421 43.334 42.3306 44.1455 41.3296 44.1455H2.6629C1.66189 44.1455 0.850403 43.334 0.850403 42.333V16.958C0.850403 16.3875 1.119 15.8503 1.5754 15.508L20.9087 1.00801ZM4.4754 17.8643V40.5205H39.5171V17.8643L21.9962 4.72363L4.4754 17.8643Z"
          fill={color}
        />
        <path
          id="Vector 128 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.3296 27.2285H21.9962V23.6035H41.3296V27.2285Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default HouseIcon;
